module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"work":"Work","about":"About us","jobs":"Jobs","services":"Services","email":"hello@23g.io"},"nl":{"work":"Werk","about":"Over ons","jobs":"Werken bij","services":"Diensten","email":"hallo@23g.nl"}}')
  delete Component.options._Ctor
}
